"use client";

import { c as _c } from "react/compiler-runtime";
import { EmptyState, Spinner, useTheme } from "@opensea/ui-kit";
import { generateUUID } from "@opensea/utils";
import { Suspense, useEffect, useState } from "react";
import { useClient } from "urql";
import { useTranslations } from "use-intl";
import { MoonPayNftCheckoutWidget, MoonPayProvider } from "../../../lib/moonpay/components";
import { MOONPAY_NFT_CLIENT_API_KEY, MOONPAY_THEME_ID } from "../../../lib/moonpay/constants";
import { fetchMoonPayTransaction } from "../../../lib/moonpay/fetchMoonPayTransaction";
import { fetchMoonPayCheckoutUrlSignature } from "../../../lib/moonpay/fetchMoonPayUrlSignature";
import { useIsMoonPayAllowed } from "../../../lib/moonpay/useIsMoonPayAllowed";
import { useAddress } from "../../../polychain/hooks";
const POLL_INTERVAL = 3000;
export const MoonPayCheckoutWidget = t0 => {
  const $ = _c(22);
  const {
    item,
    listingId,
    onTransactionCreated
  } = t0;
  const {
    isBuyWithCardAllowed,
    isLoading
  } = useIsMoonPayAllowed();
  const {
    theme
  } = useTheme();
  const [hasError, setHasError] = useState(false);
  const address = useAddress();
  const t = useTranslations("wallet.MoonPayCheckoutWidget");
  const client = useClient();
  const [moonpayTxId] = useState(_temp);
  let t1;
  let t2;
  if ($[0] !== item.chain || $[1] !== moonpayTxId || $[2] !== onTransactionCreated) {
    t1 = () => {
      let pollingCancelled = false;
      const pollMoonpayTx = async () => {
        if (!pollingCancelled) {
          const moonpayTx = await fetchMoonPayTransaction(moonpayTxId).catch(_temp2);
          if (!moonpayTx?.nftTransaction?.transactionHash) {
            setTimeout(pollMoonpayTx, POLL_INTERVAL);
            return;
          }
          onTransactionCreated?.({
            chain: item.chain.identifier,
            transactionHash: moonpayTx.nftTransaction.transactionHash
          });
        }
      };
      pollMoonpayTx();
      return () => {
        pollingCancelled = true;
      };
    };
    t2 = [moonpayTxId, onTransactionCreated, item.chain];
    $[0] = item.chain;
    $[1] = moonpayTxId;
    $[2] = onTransactionCreated;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!(isBuyWithCardAllowed || isLoading)) {
    let t3;
    if ($[5] !== t) {
      t3 = t("notSupported");
      $[5] = t;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t3) {
      t4 = <EmptyState title={t3} variant="no-data" />;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  if (hasError) {
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <EmptyState variant="no-data" />;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Spinner size="lg" />;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== client) {
    t4 = async url => {
      const result = await fetchMoonPayCheckoutUrlSignature(url, client);
      if (!result) {
        setHasError(true);
      }
      return result;
    };
    $[11] = client;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      height: "100%",
      margin: 0,
      width: "100%",
      border: "1px solid rgb(var(--color-border-1))"
    };
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== address || $[15] !== item.contractAddress || $[16] !== item.tokenId || $[17] !== listingId || $[18] !== moonpayTxId || $[19] !== t4 || $[20] !== theme) {
    t6 = <Suspense fallback={t3}><MoonPayProvider apiKey={MOONPAY_NFT_CLIENT_API_KEY}><MoonPayNftCheckoutWidget contractAddress={item.contractAddress} externalTransactionId={moonpayTxId} listingId={listingId} onUrlSignatureRequested={t4} sellType="Secondary" style={t5} theme={theme} themeId={MOONPAY_THEME_ID} tokenId={item.tokenId} variant="embedded" walletAddress={address} /></MoonPayProvider></Suspense>;
    $[14] = address;
    $[15] = item.contractAddress;
    $[16] = item.tokenId;
    $[17] = listingId;
    $[18] = moonpayTxId;
    $[19] = t4;
    $[20] = theme;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};
function _temp() {
  return generateUUID().replace(/-/g, "").slice(0, 12);
}
function _temp2() {}